export const MAIN_PROOFY_URL = 'https://proofy.io';